import * as React from 'react';
import { observer } from 'mobx-react';
import { routingStore } from '../../../common/stores/routing';

export const ExamPracticalSubmissionsPage = observer(
  class ExamPracticalSubmissionsPage extends React.Component {
    async componentDidMount() {
      routingStore.replace('');
    }

    render() {
      return <div />;
    }
  }
);
